"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _dateUtils = require("../dateUtils");

var _jalaaliJs = _interopRequireDefault(require("jalaali-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Days = /*#__PURE__*/function (_React$Component) {
  _inherits(Days, _React$Component);

  var _super = _createSuper(Days);

  function Days(props) {
    var _this;

    _classCallCheck(this, Days);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isDateEnabled", function (date) {
      if (_this.props.filterDate) {
        return _this.props.filterDate(date);
      }

      return true;
    });

    _this.state = {
      selectedDay: _this.props.selectedDay
    };
    var now = new Date();
    _this.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return _this;
  }

  _createClass(Days, [{
    key: "dayClicked",
    value: function dayClicked(element, e) {
      var _this2 = this;

      if (e) {
        e.preventDefault();
      }

      if (!!this.state.selectedDay) {
        var selectedRef = this.state.selectedDay.getTime().toString();

        if (!!this.refs[selectedRef]) {
          this.refs[selectedRef].className = this.refs[selectedRef].className.replace('selected', '');
        }
      }

      this.setState({
        selectedDay: element
      }, function () {
        _this2.refs[element.getTime().toString()].className += ' selected';

        _this2.props.clickEvent(element);
      });
    }
  }, {
    key: "renderDays",
    value: function renderDays() {
      var _this3 = this;

      var _this$props = this.props,
          gregorian = _this$props.gregorian,
          firstDay = _this$props.firstDay,
          selectedYear = _this$props.selectedYear,
          currentMonth = _this$props.currentMonth,
          selectedDay = _this$props.selectedDay,
          daysCount = _this$props.daysCount;
      var year = selectedYear;
      var month = currentMonth;
      var result = [];

      var _loop = function _loop(i) {
        var addedClass = '';
        var marginRight = '0%';
        var number = (0, _dateUtils.mapToFarsi)(i);
        if (i === 1) marginRight = firstDay * 14.28 + '%';
        var date = void 0;

        if (gregorian) {
          date = new Date(year, month - 1, i);
        } else {
          var g = _jalaaliJs.default.toGregorian(year, month, i);

          date = new Date(g.gy, g.gm - 1, g.gd);
        } // console.log(this.today, date)


        if (_this3.today && date.getTime() === _this3.today.getTime()) addedClass += ' today';
        if (selectedDay && (0, _dateUtils.isTheSameDay)(date, selectedDay)) addedClass += ' selected';

        var enable = _this3.isDateEnabled(date);

        if (!enable) {
          result.push( /*#__PURE__*/_react.default.createElement("div", {
            className: 'day-items' + addedClass,
            ref: date.getTime().toString(),
            key: date.getTime().toString(),
            style: {
              background: '#ccc',
              cursor: 'default',
              marginRight: marginRight
            }
          }, number));
        } else if (enable) {
          result.push( /*#__PURE__*/_react.default.createElement("div", {
            className: 'day-items' + addedClass,
            ref: date.getTime().toString(),
            key: date.getTime().toString(),
            style: {
              marginRight: marginRight
            },
            onClick: function onClick(e) {
              return _this3.dayClicked(date, e);
            }
          }, number));
        }
      };

      for (var i = 1; i <= daysCount; i++) {
        _loop(i);
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-days"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "holder"
      }, !!this.props.daysCount && this.renderDays()));
    }
  }]);

  return Days;
}(_react.default.Component);

var _default = Days;
exports.default = _default;